// Data Size Converter Tool — bytes / KB / MB / GB / KiB / MiB / GiB conversion.
import { m } from "@/paraglide/messages";
import type { Tool } from "../index";

export const dataSizeTool: Tool = {
  id: "data-size",
  name: () => m.ds_tool_name(),
  description: () => m.ds_tool_description(),
  icon: "💾",
  basePath: "/data-size",
  status: "stable",
  tags: ["data", "bytes", "storage", "converter"],
  pages: [
    {
      name: () => m.ds_nav_main(),
      path: "/data-size",
      description: () => m.ds_nav_main_desc(),
      icon: "💾",
    },
  ],
};
